require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./button"), require("./flexlayout"), require("./tooltip"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./button", "./flexlayout", "./tooltip"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./button"), require("./flexlayout"), require("./tooltip")) : factory(root["./utils"], root["./svgicon"], root["./button"], root["./flexlayout"], root["./tooltip"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__16__, __WEBPACK_EXTERNAL_MODULE__21__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[27],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__21__;

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(282);


/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Grid = _interopRequireDefault(__webpack_require__(283));

exports["default"] = _Grid["default"];
exports.Grid = _Grid["default"];

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _button = _interopRequireDefault(__webpack_require__(15));

var _tooltip = _interopRequireDefault(__webpack_require__(21));

var _flexlayout = _interopRequireDefault(__webpack_require__(16));

var _overflowMenuVertical_ = _interopRequireDefault(__webpack_require__(64));

var _reactVirtualized = __webpack_require__(284);

var _ArrowKeyStepper = _interopRequireDefault(__webpack_require__(285));

var _StringResource = _interopRequireDefault(__webpack_require__(286));

var _Grid = _interopRequireDefault(__webpack_require__(288));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var isEqual = _utils.lodash.isEqual,
    uniqueId = _utils.lodash.uniqueId;

var gridClassName = _Grid["default"].gridClassName.replace(/"/g, '');

var defaultGridAttributes = {
  ROW_OPTIONS_COLUMN_WIDTH: 40,
  ROW_HEIGHT: 40,
  COLUMN_WIDTH: 170,
  SCROLL_TO_COLUMN: -1,
  SCROLL_TO_ROW: -1,
  MAX_COLUMN_WIDTH: 400,
  OVERSCAN_COLUMN_COUNT: 10,
  OVERSCAN_ROW_COUNT: 20
};

function isAutoMeasurePropsValid(_ref, propName, componentName) {
  var autoMeasureColumnWidth = _ref.autoMeasureColumnWidth,
      autoMeasureRowHeight = _ref.autoMeasureRowHeight,
      columnWidth = _ref.columnWidth,
      rowHeight = _ref.rowHeight;

  if (propName === 'autoMeasureColumnWidth' && autoMeasureColumnWidth) {
    if (!rowHeight) {
      return console.warn( // eslint-disable-line
      "If 'autoMeasureColumnWidth' is passed, it must be accompanied with the measurement prop 'rowHeight', or default will be used.");
    }

    if (columnWidth) {
      return new Error("Invalid prop '" + propName + "' passed to '" + componentName + "'. If 'autoMeasureColumnWidth' is passed, then you cannot pass 'columnWidth'.");
    }
  }

  if (propName === 'autoMeasureRowHeight' && autoMeasureRowHeight) {
    if (!columnWidth) {
      return console.warn( // eslint-disable-line
      "If 'autoMeasureRowHeight' is passed, it must be accompanied with the measurement prop 'columnWidth', or default will be used.");
    }

    if (rowHeight) {
      return new Error("Invalid prop '" + propName + "' passed to '" + componentName + "'. If 'autoMeasureRowHeight' is passed, then you cannot pass 'rowHeight'.");
    }
  }

  return null;
}

var Grid = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Grid, _Component);

  function Grid(_props) {
    var _this;

    _this = _Component.call(this, _props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      scrollToAlignment: 'auto'
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_multiGridRef", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_multiGridKey", uniqueId());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setRowScrollIndex", function (_ref2) {
      var index = _ref2.index;

      _this.setState({
        focusedCell: {
          columnIndex: 0,
          rowIndex: index + _this._getFixedRows()
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setColumnScrollIndex", function (_ref3) {
      var index = _ref3.index;

      _this.setState({
        focusedCell: {
          columnIndex: index + _this._getFixedColumns(),
          rowIndex: 0
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "invalidateCellSizeAfterRender", function (_temp) {
      var _ref4 = _temp === void 0 ? {} : _temp,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex,
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex;

      _this._multiGridRef && _this._multiGridRef.invalidateCellSizeAfterRender && _this._multiGridRef.invalidateCellSizeAfterRender({
        rowIndex: rowIndex,
        columnIndex: columnIndex
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "recomputeGridSize", function (_temp2) {
      var _ref5 = _temp2 === void 0 ? {} : _temp2,
          _ref5$rowIndex = _ref5.rowIndex,
          rowIndex = _ref5$rowIndex === void 0 ? 0 : _ref5$rowIndex,
          _ref5$columnIndex = _ref5.columnIndex,
          columnIndex = _ref5$columnIndex === void 0 ? 0 : _ref5$columnIndex;

      _this._multiGridRef && _this._multiGridRef.recomputeGridSize && _this._multiGridRef.recomputeGridSize({
        rowIndex: rowIndex,
        columnIndex: columnIndex
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_initializeCellMeasureCache", function () {
      if (_this._shouldAutoMeasureColumnWidth()) {
        _this._cellMeasurerCache = new _reactVirtualized.CellMeasurerCache({
          minHeight: defaultGridAttributes.ROW_HEIGHT,
          minWidth: defaultGridAttributes.COLUMN_WIDTH,
          fixedHeight: true
        });
      } else if (_this._shouldAutoMeasureRowHeight()) {
        _this._cellMeasurerCache = new _reactVirtualized.CellMeasurerCache({
          minHeight: defaultGridAttributes.ROW_HEIGHT,
          minWidth: defaultGridAttributes.COLUMN_WIDTH,
          fixedWidth: true
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_resetScrollToIndices", function () {
      _this.setState({
        focusedCell: {
          columnIndex: defaultGridAttributes.SCROLL_TO_COLUMN,
          rowIndex: defaultGridAttributes.SCROLL_TO_ROW
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_shouldAutoMeasureColumnWidth", function (props) {
      if (props === void 0) {
        props = _this.props;
      }

      return !!(props.autoMeasureColumnWidth && !props.columnWidth);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_shouldAutoMeasureRowHeight", function (props) {
      if (props === void 0) {
        props = _this.props;
      }

      return !!(props.autoMeasureRowHeight && !props.rowHeight);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onSectionRendered", function (_ref6) {
      var rowStopIndex = _ref6.rowStopIndex,
          columnStopIndex = _ref6.columnStopIndex,
          rowStartIndex = _ref6.rowStartIndex,
          columnStartIndex = _ref6.columnStartIndex;
      var _this$props = _this.props,
          getMoreData = _this$props.getMoreData,
          onAfterGridUpdate = _this$props.onAfterGridUpdate;
      onAfterGridUpdate && onAfterGridUpdate({
        rowEnd: rowStopIndex,
        colEnd: columnStopIndex,
        rowStart: rowStartIndex,
        colStart: columnStartIndex
      });
      var rowOffset = _this._getRowCount() - _this._getFixedRows() - 1;

      if (rowStopIndex === rowOffset) {
        getMoreData && getMoreData();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getColumnCount", function (props) {
      if (props === void 0) {
        props = _this.props;
      }

      return props.numColumns + _this._getFixedColumns(props);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getRowCount", function (props) {
      if (props === void 0) {
        props = _this.props;
      }

      return props.numRows + _this._getFixedRows(props);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getFixedColumns", function (props) {
      if (props === void 0) {
        props = _this.props;
      }

      var fixedColumns = (props.fixedColumns || 0) + (props.useRowOptionsColumn ? 1 : 0);
      return fixedColumns > 0 ? fixedColumns : 0;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getFixedRows", function (props) {
      if (props === void 0) {
        props = _this.props;
      }

      return props.fixedRows;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getRowOverscan", function (props) {
      if (props === void 0) {
        props = _this.props;
      }

      var overscan = props.overscanRowCount;
      return overscan === 0 || overscan > 0 ? overscan : defaultGridAttributes.OVERSCAN_ROW_COUNT;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getColumnOverscan", function (props) {
      if (props === void 0) {
        props = _this.props;
      }

      var overscan = props.overscanColumnCount;
      return overscan === 0 || overscan > 0 ? overscan : defaultGridAttributes.OVERSCAN_COLUMN_COUNT;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isFixedRowScrollable", function () {
      return _this.props.numRows === 0 && _this.props.fixedRows > 0;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_bidiStyles", function () {
      if (_this.props.dir === 'rtl') {
        // HACK: react-virtualized (RV) doesn't support RTL, we perform a rotational transform
        // to get around this issue. Note that RV explicitly sets direction to ltr as a
        // band aid solution since rtl breaks the grid.
        // Refer to https://github.com/bvaughn/react-virtualized/issues/454
        return {
          transform: 'rotateY(180deg)',
          WebkitFontSmoothing: 'antialiased',
          justifyContent: 'flex-end'
        };
      }

      return {
        justifyContent: 'flex-start'
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_constrainColumnWidth", function (width) {
      return Math.min(width, _this.props.maxColumnWidth);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_cellRenderer", function (_ref7) {
      var columnIndex = _ref7.columnIndex,
          key = _ref7.key,
          rowIndex = _ref7.rowIndex,
          _ref7$style = _ref7.style,
          style = _ref7$style === void 0 ? {} : _ref7$style,
          parent = _ref7.parent;
      var focusedCell = _this.state.focusedCell;
      var focusedClassname = {
        'cell-is-focused': focusedCell.columnIndex === columnIndex && focusedCell.rowIndex === rowIndex
      };
      var _this$props2 = _this.props,
          useRowOptionsColumn = _this$props2.useRowOptionsColumn,
          onFixedCornerCellMenu = _this$props2.onFixedCornerCellMenu;

      var fixedColumns = _this._getFixedColumns();

      var fixedRows = _this._getFixedRows(); // HACK: When using CellMeasurer with MultiGrid there is a bug. There are two cases to consider:
      // 1. fixedHeight: true => width will auto measure. Produces correct behaviour.
      // 2. fixedWidth: true => height will auto measure. Incorrect behaviour.
      // It seems that when CellMeasurer._getCellMeasurements runs, node.style.width is auto which
      // means height is being measured before the before the width is applied. To remedy this,
      // we force set the dimension styles when it's auto.
      // Refer to https://github.com/bvaughn/react-virtualized/issues/1354


      if (_this._shouldAutoMeasureRowHeight()) {
        if (style.width === 'auto') {
          var _this$_getColumnWidth = _this._getColumnWidthProps(),
              columnWidth = _this$_getColumnWidth.columnWidth;

          style.width = columnWidth({
            index: columnIndex
          });
        } else {
          style.width = _this._constrainColumnWidth(style.width);
        }

        style.whiteSpace = 'normal';
      }

      if (_this._shouldAutoMeasureColumnWidth()) {
        style.whiteSpace = 'nowrap';
      }

      var cellBaseProps = {
        cellOnClick: function cellOnClick() {
          return _this._selectCell({
            scrollToColumn: columnIndex,
            scrollToRow: rowIndex
          });
        },
        className: focusedClassname,
        key: key,
        style: (0, _extends2["default"])({}, style, _this._bidiStyles())
      };
      var cell = null;

      if (useRowOptionsColumn && columnIndex === 0) {
        if (rowIndex === 0 && onFixedCornerCellMenu) {
          cell = _this._fixedCornerCellRenderer((0, _extends2["default"])({}, cellBaseProps, {
            rowIndex: rowIndex
          }));
        } else {
          cell = _this._fixedColumnCellRenderer((0, _extends2["default"])({}, cellBaseProps));
        }
      } else if (columnIndex < fixedColumns && rowIndex < fixedRows) {
        cell = _this._fixedCornerCellRenderer((0, _extends2["default"])({}, cellBaseProps, {
          columnIndex: columnIndex,
          rowIndex: rowIndex
        }));
      } else if (columnIndex < fixedColumns) {
        cell = _this._fixedColumnCellRenderer((0, _extends2["default"])({}, cellBaseProps, {
          columnIndex: columnIndex,
          rowIndex: rowIndex - fixedRows
        }));
      } else if (rowIndex < fixedRows) {
        cell = _this._fixedRowCellRenderer((0, _extends2["default"])({}, cellBaseProps, {
          columnIndex: columnIndex - fixedColumns,
          rowIndex: rowIndex
        }));
      } else {
        cell = _this._cellRendererMain((0, _extends2["default"])({}, cellBaseProps, {
          columnIndex: columnIndex - fixedColumns,
          rowIndex: rowIndex - fixedRows
        }));
      }

      if (_this._shouldAutoMeasureColumnWidth() || _this._shouldAutoMeasureRowHeight()) {
        return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.CellMeasurer, {
          key: key,
          parent: parent,
          cache: _this._cellMeasurerCache,
          columnIndex: columnIndex,
          rowIndex: rowIndex
        }, cell);
      }

      return cell;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_hasClickableHeaderMenu", function (row) {
      var fixedRows = _this._getFixedRows();

      return row === 0 && fixedRows > 0 && _this.props.onFixedRowCellMenu;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onCornerMenuClicked", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var clientX = e.clientX,
          clientY = e.clientY;

      if (clientX === 0 && clientY === 0) {
        var _e$currentTarget$getB = e.currentTarget.getBoundingClientRect(),
            x = _e$currentTarget$getB.x,
            y = _e$currentTarget$getB.y;

        clientX = x;
        clientY = y;
      }

      _this.props.onFixedCornerCellMenu && _this.props.onFixedCornerCellMenu(clientX, clientY, 0, 0);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fixedCornerCellRenderer", function (_ref8) {
      var className = _ref8.className,
          columnIndex = _ref8.columnIndex,
          key = _ref8.key,
          rowIndex = _ref8.rowIndex,
          style = _ref8.style,
          cellOnClick = _ref8.cellOnClick;
      var _this$props3 = _this.props,
          fixedCornerCellMenuIcon = _this$props3.fixedCornerCellMenuIcon,
          rowOptionsColumnText = _this$props3.rowOptionsColumnText,
          dir = _this$props3.dir,
          useRowOptionsColumn = _this$props3.useRowOptionsColumn,
          fixedCellVerticalBorder = _this$props3.fixedCellVerticalBorder,
          fixedCellHorizontalBorder = _this$props3.fixedCellHorizontalBorder;
      var borderClassName = fixedCellVerticalBorder && (dir === 'rtl' ? {
        'rtl-border': true
      } : {
        'ltr-border': true
      });
      borderClassName = (0, _utils.classnames)(borderClassName, {
        fixedCellHorizontalBorder: fixedCellHorizontalBorder
      });

      if (useRowOptionsColumn) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _utils.classnames)(gridClassName + "__top-left-grid-cell", className, borderClassName),
          key: key,
          style: style,
          onKeyDown: function onKeyDown(e) {
            return _this._onKeyDown(e, cellOnClick);
          },
          onClick: cellOnClick
        }, /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], {
          justifyContent: "center",
          height: "100%",
          direction: "column"
        }, /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
          title: rowOptionsColumnText
        }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
          fullWidth: true,
          onClick: _this._onCornerMenuClicked,
          onContextMenu: _this._onCornerMenuClicked,
          tabIndex: 0,
          variant: "inline",
          "data-tid": "ba-common-grid__menu-button",
          icon: /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
            pad: true,
            iconId: fixedCornerCellMenuIcon ? fixedCornerCellMenuIcon.id : _overflowMenuVertical_["default"].id,
            size: "small"
          })
        }))));
      }

      var fixedCornerCellRenderer = _this.props.fixedCornerCellRenderer;
      var gridCellProps = {
        className: (0, _utils.classnames)('top-left-grid-cell', className),
        style: style,
        key: key,
        onClick: cellOnClick,
        dir: dir
      };
      return fixedCornerCellRenderer(rowIndex, columnIndex, gridCellProps);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (e, clickHandler) {
      if (e.keyCode === 32 || e.keyCode === 13) {
        clickHandler && clickHandler();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fixedColumnCellRenderer", function (_ref9) {
      var className = _ref9.className,
          columnIndex = _ref9.columnIndex,
          key = _ref9.key,
          rowIndex = _ref9.rowIndex,
          style = _ref9.style,
          cellOnClick = _ref9.cellOnClick;
      var _this$props4 = _this.props,
          fixedCellVerticalBorder = _this$props4.fixedCellVerticalBorder,
          fixedCellHorizontalBorder = _this$props4.fixedCellHorizontalBorder,
          useRowOptionsColumn = _this$props4.useRowOptionsColumn;
      var borderClassName = fixedCellVerticalBorder && (dir === 'rtl' ? {
        'rtl-border': true
      } : {
        'ltr-border': true
      });
      borderClassName = (0, _utils.classnames)(borderClassName, {
        fixedCellHorizontalBorder: fixedCellHorizontalBorder
      });

      if (useRowOptionsColumn) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _utils.classnames)(gridClassName + "__bottom-left-grid-cell", className, borderClassName),
          key: key,
          style: style,
          onKeyDown: function onKeyDown(e) {
            return _this._onKeyDown(e, cellOnClick);
          },
          onClick: cellOnClick
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            width: defaultGridAttributes.ROW_OPTIONS_COLUMN_WIDTH
          }
        }));
      }

      var _this$props5 = _this.props,
          fixedColumnCellRenderer = _this$props5.fixedColumnCellRenderer,
          dir = _this$props5.dir;
      var gridCellProps = {
        className: (0, _utils.classnames)('bottom-left-grid-cell', className),
        style: style,
        key: key,
        onClick: cellOnClick,
        dir: dir
      };
      return fixedColumnCellRenderer(rowIndex, columnIndex, gridCellProps);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_cellRendererMain", function (_ref10) {
      var className = _ref10.className,
          columnIndex = _ref10.columnIndex,
          key = _ref10.key,
          rowIndex = _ref10.rowIndex,
          style = _ref10.style,
          cellOnClick = _ref10.cellOnClick;
      var _this$props6 = _this.props,
          selectedColumns = _this$props6.selectedColumns,
          dataCellRenderer = _this$props6.dataCellRenderer,
          dir = _this$props6.dir;
      var gridCellProps = {
        className: (0, _utils.classnames)('bottom-right-grid-cell', className, {
          'cell-is-selected': selectedColumns.includes(columnIndex)
        }),
        style: style,
        key: key,
        onClick: cellOnClick,
        dir: dir
      };
      return dataCellRenderer(rowIndex, columnIndex, gridCellProps);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fixedRowCellOnMenu", function (rowIndex, columnIndex, cellOnClick) {
      return function (e) {
        if (_this._hasClickableHeaderMenu(rowIndex)) {
          e.preventDefault();

          _this.props.onFixedRowCellMenu(e.clientX, e.clientY, rowIndex, columnIndex);
        }

        cellOnClick();
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_fixedRowCellRenderer", function (_ref11) {
      var className = _ref11.className,
          columnIndex = _ref11.columnIndex,
          key = _ref11.key,
          rowIndex = _ref11.rowIndex,
          style = _ref11.style,
          cellOnClick = _ref11.cellOnClick;
      var _this$props7 = _this.props,
          selectedColumns = _this$props7.selectedColumns,
          fixedRowCellRenderer = _this$props7.fixedRowCellRenderer,
          dir = _this$props7.dir;
      var gridCellProps = {
        className: (0, _utils.classnames)(className, {
          'top-right-grid-cell header-cell': rowIndex === 0,
          'bottom-right-grid-cell': rowIndex > 0,
          'cell-is-selected': selectedColumns.includes(columnIndex)
        }),
        style: style,
        key: key,
        onClick: _this._fixedRowCellOnMenu(rowIndex, columnIndex, cellOnClick),
        onContextMenu: _this._fixedRowCellOnMenu(rowIndex, columnIndex, cellOnClick),
        dir: dir
      };
      return fixedRowCellRenderer(rowIndex, columnIndex, gridCellProps);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_selectCell", function (_ref12) {
      var scrollToColumn = _ref12.scrollToColumn,
          scrollToRow = _ref12.scrollToRow;
      var _this$props8 = _this.props,
          onCellFocus = _this$props8.onCellFocus,
          focusedCell = _this$props8.focusedCell;

      if (!focusedCell) {
        _this.setState({
          focusedCell: {
            columnIndex: scrollToColumn,
            rowIndex: scrollToRow
          }
        });
      }

      onCellFocus && onCellFocus({
        columnIndex: scrollToColumn,
        rowIndex: scrollToRow
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getFocusedCellContent", function () {
      var _this$state$focusedCe = _this.state.focusedCell,
          rowIndex = _this$state$focusedCe.rowIndex,
          columnIndex = _this$state$focusedCe.columnIndex; // Set focused contents when within grid boundaries

      return rowIndex >= 0 && columnIndex >= 0 ? _this._cellRenderer({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      }) : null;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_makeConstrained", function (fn) {
      return function (ref) {
        return _this._constrainColumnWidth(fn(ref));
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getColumnWidthProps", function () {
      var _this$props9 = _this.props,
          columnWidth = _this$props9.columnWidth,
          useRowOptionsColumn = _this$props9.useRowOptionsColumn;
      var columnWidthProp = null;

      if (_this._shouldAutoMeasureColumnWidth()) {
        columnWidthProp = function columnWidthProp(ref) {
          if (useRowOptionsColumn && ref.index === 0) {
            return defaultGridAttributes.ROW_OPTIONS_COLUMN_WIDTH;
          }

          return _this._cellMeasurerCache.columnWidth(ref);
        };
      } else if (typeof columnWidth === 'function') {
        columnWidthProp = function columnWidthProp(_ref13) {
          var index = _ref13.index;

          if (useRowOptionsColumn && index === 0) {
            return defaultGridAttributes.ROW_OPTIONS_COLUMN_WIDTH;
          }

          return columnWidth(index);
        };
      } else {
        columnWidthProp = function columnWidthProp(_ref14) {
          var index = _ref14.index;

          if (useRowOptionsColumn && index === 0) {
            return defaultGridAttributes.ROW_OPTIONS_COLUMN_WIDTH;
          }

          return defaultGridAttributes.COLUMN_WIDTH;
        };
      }

      return {
        columnWidth: _this._shouldAutoMeasureColumnWidth() ? columnWidthProp : _this._makeConstrained(columnWidthProp)
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getRowHeightProps", function () {
      var _rowHeight = _this.props.rowHeight;

      if (_this._shouldAutoMeasureRowHeight()) {
        return {
          rowHeight: _this._cellMeasurerCache.rowHeight
        };
      } else if (typeof _rowHeight === 'function') {
        return {
          rowHeight: function rowHeight(_ref15) {
            var index = _ref15.index;
            return _rowHeight(index);
          }
        };
      }

      return {
        rowHeight: function rowHeight() {
          return defaultGridAttributes.ROW_HEIGHT;
        }
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getMeasurementCacheProps", function () {
      if (_this._shouldAutoMeasureColumnWidth() || _this._shouldAutoMeasureRowHeight()) {
        return {
          deferredMeasurementCache: _this._cellMeasurerCache
        };
      }

      return {};
    });

    _this._initializeCellMeasureCache();

    return _this;
  }

  var _proto = Grid.prototype;

  _proto.componentWillMount = function componentWillMount() {
    var focusedCell = this.props.focusedCell;
    var defaultFocusedCell = {
      columnIndex: defaultGridAttributes.SCROLL_TO_COLUMN,
      rowIndex: defaultGridAttributes.SCROLL_TO_ROW
    };
    this.setState({
      focusedCell: focusedCell || defaultFocusedCell
    });
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    // Reset scroll indices when there are new/empty selected columns
    if (!isEqual(nextProps.selectedColumns, this.props.selectedColumns)) {
      this._resetScrollToIndices();
    }

    var didAutoMeasureChange = this._shouldAutoMeasureColumnWidth(nextProps) !== this._shouldAutoMeasureColumnWidth() || this._shouldAutoMeasureRowHeight(nextProps) !== this._shouldAutoMeasureRowHeight(); // The grid doesn't properly update the cache, when we switch auto measurement props.
    // Therefore, we manually create new caches per auto measurement props change.


    if (didAutoMeasureChange) {
      this._initializeCellMeasureCache();
    } // The multigrid doesn't properly update these values change (deferredMeasurementCache, fixedColumnCount, fixedRowCount)
    // Therefore, we'll need to force a remount of the component.


    if (didAutoMeasureChange || this._getFixedRows(nextProps) !== this._getFixedRows() || this._getColumnCount(nextProps) !== this._getColumnCount()) {
      this._multiGridKey = uniqueId();
    }

    var focusedCell = nextProps.focusedCell;

    if (focusedCell) {
      this.setState({
        focusedCell: focusedCell
      });
    }
  };

  _proto.forceUpdateGrids = function forceUpdateGrids() {
    this._multiGridRef && this._multiGridRef.forceUpdateGrids && this._multiGridRef.forceUpdateGrids();
  };

  _proto.render = function render() {
    var _this2 = this;

    var adjustedColumnCount = this._getColumnCount();

    var adjustedRowCount = this._getRowCount();

    var adjustedFixedColumns = this._getFixedColumns();

    var adjustedFixedRows = this._getFixedRows();

    var isFixedRowScrollable = this._isFixedRowScrollable();

    var _this$state = this.state,
        focusedCell = _this$state.focusedCell,
        scrollToAlignment = _this$state.scrollToAlignment;
    var _this$props10 = this.props,
        onFixedCornerCellMenu = _this$props10.onFixedCornerCellMenu,
        onFixedRowCellMenu = _this$props10.onFixedRowCellMenu,
        style = _this$props10.style,
        className = _this$props10.className;
    return /*#__PURE__*/_react["default"].createElement(_ArrowKeyStepper["default"], {
      className: gridClassName + " full-height " + className,
      columnCount: adjustedColumnCount,
      onScrollToChange: this._selectCell,
      mode: "cells",
      rowCount: adjustedRowCount,
      scrollToColumn: focusedCell.columnIndex,
      scrollToRow: focusedCell.rowIndex,
      fixedColumns: adjustedFixedColumns,
      fixedRows: adjustedFixedRows,
      onFixedCornerCellMenu: onFixedCornerCellMenu,
      onFixedRowCellMenu: onFixedRowCellMenu,
      style: style
    }, function (_ref16) {
      var scrollToColumn = _ref16.scrollToColumn,
          scrollToRow = _ref16.scrollToRow,
          registerChild = _ref16.registerChild;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: gridClassName + "__arrow-key-stepper full-height",
        tabIndex: 0,
        onBlur: function onBlur() {
          return _this2._resetScrollToIndices();
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        key: scrollToColumn + "_" + scrollToRow,
        "aria-live": "polite",
        className: gridClassName + " visually-hidden"
      }, _this2._getFocusedCellContent()), /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, null, function (_ref17) {
        var width = _ref17.width,
            height = _ref17.height;
        return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.MultiGrid, (0, _extends2["default"])({}, _this2._getMeasurementCacheProps(), _this2._getColumnWidthProps(), _this2._getRowHeightProps(), {
          scrollToAlignment: scrollToAlignment,
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow,
          cellRenderer: _this2._cellRenderer,
          columnCount: adjustedColumnCount,
          fixedRowCount: adjustedFixedRows,
          fixedColumnCount: adjustedFixedColumns,
          rowCount: adjustedRowCount,
          height: height - 1,
          width: width - 1,
          overscanColumnCount: _this2._getColumnOverscan(),
          overscanRowCount: _this2._getRowOverscan(),
          onSectionRendered: _this2._onSectionRendered,
          enableFixedRowScroll: isFixedRowScrollable,
          hideTopRightGridScrollbar: isFixedRowScrollable,
          ref: function ref(node) {
            registerChild(node);
            _this2._multiGridRef = node;
          },
          classNameBottomLeftGrid: gridClassName + "__bottom-left-grid",
          classNameBottomRightGrid: gridClassName + "__bottom-right-grid",
          classNameTopLeftGrid: gridClassName + "__top-left-grid",
          classNameTopRightGrid: gridClassName + "__top-right-grid",
          style: _this2._bidiStyles(),
          tabIndex: -1,
          key: _this2._multiGridKey
        }));
      }));
    });
  };

  return Grid;
}(_react.Component);

exports["default"] = Grid;
(0, _defineProperty2["default"])(Grid, "propTypes", {
  /** Let the grid auto measure a cell's width only, cannot be used with columnWidth. */
  autoMeasureColumnWidth: _propTypes["default"].bool && isAutoMeasurePropsValid,

  /** Let the grid auto measure a cell's height only, cannot be used with rowHeight. */
  autoMeasureRowHeight: _propTypes["default"].bool && isAutoMeasurePropsValid,

  /** Class attributes applied to the grid container */
  className: _propTypes["default"].string,

  /** Callback function that returns the width of a column given its index, defaults to 170. */
  columnWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].func]),

  /** Callback function that returns cell element for given row and column index for the data part of grid */
  dataCellRenderer: _propTypes["default"].func.isRequired,

  /** String for bidi support */
  dir: _propTypes["default"].oneOf(['ltr', 'rtl']),

  /** Number of fixed columns in grid, defaults to 0 */
  fixedColumns: _propTypes["default"].number,

  /** ID of svg icon to be used in row options menu cell (temporary hack by design) */
  fixedCornerCellMenuIcon: _propTypes["default"].object,

  /** Callback function that returns cell element for given row and column index for fixed column part of grid */
  fixedColumnCellRenderer: _propTypes["default"].func,

  /** Callback function that returns cell element for given row and column index for fixed corner part of grid */
  fixedCornerCellRenderer: _propTypes["default"].func,

  /** Callback function that returns cell element for given row and column index for fixed row part of grid */
  fixedRowCellRenderer: _propTypes["default"].func,

  /** Number of fixed row headers in grid, defaults to 0 */
  fixedRows: _propTypes["default"].number,

  /** Indices of the focused cell */
  focusedCell: _propTypes["default"].object,

  /** Callback that is called when the bottom of the grid is reached. */
  getMoreData: _propTypes["default"].func,

  /** Maximum column width value */
  maxColumnWidth: _propTypes["default"].number,

  /** Number of columns in grid */
  numColumns: _propTypes["default"].number.isRequired,

  /** Number of rows in grid */
  numRows: _propTypes["default"].number.isRequired,

  /** Callback function that is called when a grid has updated. It passes in a range object with the visible rows and columns */
  onAfterGridUpdate: _propTypes["default"].func,

  /** Callback when cell focus is changed */
  onCellFocus: _propTypes["default"].func,

  /** Callback when the corner grid menu is clicked */
  onFixedCornerCellMenu: _propTypes["default"].func,

  /** Callback when fixed cell header is clicked in grid. useRowOptionsColumn is required */
  onFixedRowCellMenu: _propTypes["default"].func,

  /** Count of overscan column */
  overscanColumnCount: _propTypes["default"].number,

  /** Count of overscan row */
  overscanRowCount: _propTypes["default"].number,

  /** Callback function that returns the height of a row given its index, defaults to 40. */
  rowHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].func]),

  /** Text that will be shown in the corner cell menu tooltip */
  rowOptionsColumnText: _propTypes["default"].string,

  /** Array of number of columns to highlight as selected */
  selectedColumns: _propTypes["default"].array,

  /** Styles to be applied to the grid container */
  style: _propTypes["default"].object,

  /** Enable row options column */
  useRowOptionsColumn: _propTypes["default"].bool,

  /** Toggle the vertical border around the cell of the fixed cells */
  fixedCellVerticalBorder: _propTypes["default"].bool,

  /** Toggle the horizontal border around the cell of the fixed cell */
  fixedCellHorizontalBorder: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(Grid, "defaultProps", {
  selectedColumns: [],
  fixedRows: 0,
  fixedColumns: 0,
  getMoreData: function getMoreData() {
    return null;
  },
  onAfterGridUpdate: function onAfterGridUpdate() {
    return null;
  },
  autoMeasureColumnWidth: false,
  autoMeasureRowHeight: false,
  dataCellRenderer: function dataCellRenderer() {
    return null;
  },
  fixedColumnCellRenderer: function fixedColumnCellRenderer() {
    return null;
  },
  fixedCornerCellRenderer: function fixedCornerCellRenderer() {
    return null;
  },
  fixedRowCellRenderer: function fixedRowCellRenderer() {
    return null;
  },
  onFixedRowCellMenu: function onFixedRowCellMenu() {
    return null;
  },
  rowOptionsColumnText: _StringResource["default"].get('changeGridSettings'),
  dir: 'ltr',
  className: '',
  style: {},
  maxColumnWidth: defaultGridAttributes.MAX_COLUMN_WIDTH,
  fixedCellVerticalBorder: true,
  fixedCellHorizontalBorder: true
});

/***/ }),

/***/ 284:
/***/ (function(module, exports) {

module.exports = require("react-virtualized");

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(14));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var getKeyName = _utils.keyboardUtils.getKeyName,
    keyNames = _utils.keyboardUtils.keyNames;
/**
 * Forked from react-virtualized project: https://github.com/bvaughn/react-virtualized
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */

var ArrowKeyStepper = /*#__PURE__*/function (_PureComponent) {
  (0, _inheritsLoose2["default"])(ArrowKeyStepper, _PureComponent);

  function ArrowKeyStepper(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_columnStartIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_columnStopIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rowStartIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rowStopIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_registeredChild", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (event) {
      var _this$props = _this.props,
          columnCount = _this$props.columnCount,
          rowCount = _this$props.rowCount,
          onFixedCornerCellMenu = _this$props.onFixedCornerCellMenu,
          onFixedRowCellMenu = _this$props.onFixedRowCellMenu,
          fixedRows = _this$props.fixedRows,
          fixedColumns = _this$props.fixedColumns; // Don't do anything if there's no data
      // Also considered the case where the row count is adjusted

      if (rowCount === fixedRows || rowCount === 0) return;

      var _this$_getScrollState = _this._getScrollState(),
          scrollToColumnPrevious = _this$_getScrollState.scrollToColumn,
          scrollToRowPrevious = _this$_getScrollState.scrollToRow;

      var _this$_getScrollState2 = _this._getScrollState(),
          scrollToColumn = _this$_getScrollState2.scrollToColumn,
          scrollToRow = _this$_getScrollState2.scrollToRow;

      var LEFT = keyNames.LEFT,
          RIGHT = keyNames.RIGHT,
          UP = keyNames.UP,
          DOWN = keyNames.DOWN,
          F10 = keyNames.F10,
          END = keyNames.END,
          HOME = keyNames.HOME;
      var keyName = getKeyName(event);

      switch (keyName) {
        case DOWN:
          scrollToRow = Math.min(scrollToRow + 1, rowCount - 1);
          break;

        case LEFT:
          scrollToColumn = Math.max(scrollToColumn - 1, 0);
          break;

        case RIGHT:
          scrollToColumn = Math.min(scrollToColumn + 1, columnCount - 1);
          break;

        case UP:
          scrollToRow = Math.max(scrollToRow - 1, 0);
          break;

        case HOME:
          scrollToRow = fixedRows;
          break;

        case END:
          scrollToRow = rowCount - 1;
          break;

        default:
          break;
      }

      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();

        if (scrollToColumnPrevious < 0 || scrollToRowPrevious < 0) {
          // If out of bounds and key down event then set the focused cell to 0,0
          _this._updateScrollState({
            scrollToColumn: 0,
            scrollToRow: 0
          });
        } else {
          _this._updateScrollState({
            scrollToColumn: scrollToColumn,
            scrollToRow: scrollToRow
          });
        }
      } else if (keyName === F10) {
        if (event.shiftKey) {
          event.preventDefault();

          var _ReactDOM$findDOMNode = _reactDom["default"].findDOMNode(_this._registeredChild).getBoundingClientRect(),
              x = _ReactDOM$findDOMNode.x,
              y = _ReactDOM$findDOMNode.y;

          if (scrollToRow < fixedRows && scrollToColumn < fixedColumns) {
            // If in the corner grid
            onFixedCornerCellMenu && onFixedCornerCellMenu(x, y, 0, 0);
          } else if (scrollToRow === 0 && scrollToColumn >= fixedColumns && onFixedRowCellMenu) {
            // If in row header
            var gridCellOffset = _this._registeredChild._bottomRightGrid.getOffsetForCell({
              alignment: 'start',
              columnIndex: scrollToColumn,
              rowIndex: scrollToRow
            });

            var scrollContainer = _reactDom["default"].findDOMNode(_this._registeredChild._bottomRightGrid);

            onFixedRowCellMenu && onFixedRowCellMenu(gridCellOffset.scrollLeft + x - scrollContainer.scrollLeft, y, scrollToRow, scrollToColumn - fixedColumns);
          }
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onSectionRendered", function (_ref) {
      var columnStartIndex = _ref.columnStartIndex,
          columnStopIndex = _ref.columnStopIndex,
          rowStartIndex = _ref.rowStartIndex,
          rowStopIndex = _ref.rowStopIndex;
      _this._columnStartIndex = columnStartIndex;
      _this._columnStopIndex = columnStopIndex;
      _this._rowStartIndex = rowStartIndex;
      _this._rowStopIndex = rowStopIndex;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getScrollState", function () {
      return _this.props.isControlled ? _this.props : _this.state;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_updateScrollState", function (_ref2) {
      var scrollToColumn = _ref2.scrollToColumn,
          scrollToRow = _ref2.scrollToRow;
      var _this$props2 = _this.props,
          isControlled = _this$props2.isControlled,
          onScrollToChange = _this$props2.onScrollToChange;

      if (typeof onScrollToChange === 'function') {
        onScrollToChange({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }

      if (!isControlled) {
        _this.setState({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_registerChild", function (child) {
      _this._registeredChild = child;
    });
    _this.state = {
      scrollToColumn: props.scrollToColumn,
      scrollToRow: props.scrollToRow
    };
    return _this;
  }

  var _proto = ArrowKeyStepper.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.isControlled) {
      return;
    }

    var scrollToColumn = nextProps.scrollToColumn,
        scrollToRow = nextProps.scrollToRow;
    var _this$props3 = this.props,
        prevScrollToColumn = _this$props3.scrollToColumn,
        prevScrollToRow = _this$props3.scrollToRow;

    if (prevScrollToColumn !== scrollToColumn && prevScrollToRow !== scrollToRow) {
      this.setState({
        scrollToColumn: scrollToColumn,
        scrollToRow: scrollToRow
      });
    } else if (prevScrollToColumn !== scrollToColumn) {
      this.setState({
        scrollToColumn: scrollToColumn
      });
    } else if (prevScrollToRow !== scrollToRow) {
      this.setState({
        scrollToRow: scrollToRow
      });
    }
  };

  _proto.setScrollIndexes = function setScrollIndexes(_ref3) {
    var scrollToColumn = _ref3.scrollToColumn,
        scrollToRow = _ref3.scrollToRow;
    this.setState({
      scrollToRow: scrollToRow,
      scrollToColumn: scrollToColumn
    });
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        className = _this$props4.className,
        children = _this$props4.children,
        style = _this$props4.style;

    var _this$_getScrollState3 = this._getScrollState(),
        scrollToColumn = _this$_getScrollState3.scrollToColumn,
        scrollToRow = _this$_getScrollState3.scrollToRow;

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: className,
      onKeyDown: this._onKeyDown,
      style: style
    }, children({
      onSectionRendered: this._onSectionRendered,
      scrollToColumn: scrollToColumn,
      scrollToRow: scrollToRow,
      registerChild: this._registerChild
    }));
  };

  return ArrowKeyStepper;
}(_react.PureComponent);

exports["default"] = ArrowKeyStepper;
(0, _defineProperty2["default"])(ArrowKeyStepper, "propTypes", {
  isControlled: _propTypes["default"].bool,
  onScrollToChange: _propTypes["default"].func,
  scrollToColumn: _propTypes["default"].number,
  scrollToRow: _propTypes["default"].number,
  className: _propTypes["default"].string,
  children: _propTypes["default"].func,
  columnCount: _propTypes["default"].number,
  rowCount: _propTypes["default"].number,
  fixedColumns: _propTypes["default"].number,
  fixedRows: _propTypes["default"].number,
  onFixedCornerCellMenu: _propTypes["default"].func,
  onFixedRowCellMenu: _propTypes["default"].func,
  style: _propTypes["default"].object
});
(0, _defineProperty2["default"])(ArrowKeyStepper, "defaultProps", {
  isControlled: false,
  scrollToColumn: 0,
  scrollToRow: 0,
  className: '',
  style: {}
});

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _GridResources = _interopRequireDefault(__webpack_require__(287));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_GridResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

var amdi18n={"__root":{"changeGridSettings":"Change grid settings"},"__cs":{"changeGridSettings":"Změnit nastavení mřížky"},"__da":{"changeGridSettings":"Revidér gitterindstillinger"},"__de":{"changeGridSettings":"Rastereinstellungen ändern"},"__es":{"changeGridSettings":"Cambiar valores de cuadrícula"},"__fi":{"changeGridSettings":"Muuta ruudukon asetuksia"},"__fr":{"changeGridSettings":"Modifier les paramètres de grille"},"__hr":{"changeGridSettings":"Promijeni postavke mreže"},"__hu":{"changeGridSettings":"Rácsbeállítások módosítása"},"__it":{"changeGridSettings":"Modifica impostazioni griglia"},"__ja":{"changeGridSettings":"グリッド設定の変更"},"__kk":{"changeGridSettings":"Тор параметрлерін өзгерту"},"__ko":{"changeGridSettings":"눈금 설정 변경"},"__nb":{"changeGridSettings":"Endre rutenettinnstillinger"},"__nl":{"changeGridSettings":"Rasterinstellingen wijzigen"},"__no":{"changeGridSettings":"Endre rutenettinnstillinger"},"__pl":{"changeGridSettings":"Zmień ustawienia siatki"},"__pt":{"changeGridSettings":"Mudar configurações da grade"},"__pt-br":{"changeGridSettings":"Mudar configurações da grade"},"__ro":{"changeGridSettings":"Modificare setări grilă"},"__ru":{"changeGridSettings":"Изменить параметры сетки"},"__sl":{"changeGridSettings":"Spremeni nastavitve mreže"},"__sv":{"changeGridSettings":"Ändra rutnätsinställningar"},"__th":{"changeGridSettings":"เปลี่ยนการตั้งค่ากริด"},"__tr":{"changeGridSettings":"Izgara ayarlarını değiştir"},"__zh":{"changeGridSettings":"更改网格设置"},"__zh-cn":{"changeGridSettings":"更改网格设置"},"__zh-hk":{"changeGridSettings":"變更網格設定"},"__zh-mo":{"changeGridSettings":"變更網格設定"},"__zh-sg":{"changeGridSettings":"更改网格设置"},"__zh-tw":{"changeGridSettings":"變更網格設定"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(289);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-grid{height:100%}.ba-common-grid__arrow-key-stepper:focus{outline:2px solid;outline-color:#a8c0f3;outline-color:hsla(var(--focus-h, 220.8), var(--focus-s, 75.75758%), var(--focus-l, 80.58824%), 1)}.ba-common-grid__bottom-right-grid:focus,.ba-common-grid__bottom-left-grid:focus,.ba-common-grid__top-left-grid:focus,.ba-common-grid__top-right-grid:focus{outline:none}.ba-common-grid__bottom-left-grid-cell{background-color:#fff;box-sizing:border-box}.ba-common-grid__bottom-left-grid-cell.cell-is-focused::after{content:\"\";position:absolute;border:2px solid;border-color:#0f62fe;border-color:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);top:0;left:0;right:0;bottom:0;pointer-events:none}.ba-common-grid__bottom-left-grid-cell.rtl-border{border-left:1px solid #c0bfc0}.ba-common-grid__bottom-left-grid-cell.ltr-border{border-right:1px solid #c0bfc0}.ba-common-grid__bottom-left-grid-cell.is-fixedCellHorizontalBorder{border-bottom:1px solid #c0bfc0}.ba-common-grid__top-left-grid-cell{background-color:#eaeaea;background-color:hsla(var(--gray1-h, 0), var(--gray1-s, 0%), var(--gray1-l, 91.76471%), 1)}.ba-common-grid__top-left-grid-cell.cell-is-focused::after{content:\"\";position:absolute;border:2px solid;border-color:#0f62fe;border-color:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);top:0;left:0;right:0;bottom:0;pointer-events:none}.ba-common-grid__top-left-grid-cell.rtl-border{border-left:1px solid #c0bfc0}.ba-common-grid__top-left-grid-cell.ltr-border{border-right:1px solid #c0bfc0}.ba-common-grid__top-left-grid-cell.is-fixedCellHorizontalBorder{border-bottom:1px solid #c0bfc0}.ba-common-grid .full-height{height:100%}.ba-common-grid .visually-hidden{top:0;left:-2px;width:1px;height:1px;position:absolute;overflow:hidden}\n", ""]);

// exports
exports.locals = {
	"gridClassName": "\"ba-common-grid\""
};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 64:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/overflow-menu--vertical_32.js");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[281,0]]]);
});